import React from "react";
import {
  Flex,
  Skeleton as ChakraSkeleton,
  SkeletonCircle
} from "@chakra-ui/react";

const Skeleton: React.FC = () => (
  <>
    {[...new Array(5)].map((_, i) => (
      <Flex
        py="6"
        borderBottom={i === 4 ? 0 : "1px solid"}
        key={i}
        borderColor="gray.100"
        columnGap={3}
        alignItems="center"
      >
        <SkeletonCircle size="5" />
        <ChakraSkeleton h={7} w={40} />
      </Flex>
    ))}
  </>
);

export default Skeleton;
